/**
 * PostHog analytics — product analytics, visitor analytics, and session replay.
 *
 * Privacy: this app handles phone numbers, auth, and payment. Session replay is
 * configured with maskAllInputs so input VALUES are never captured. Add the
 * `ph-no-capture` class (or `data-ph-mask`) to any element whose displayed TEXT
 * is sensitive and should be masked in replay.
 *
 * The phc_ key is the client-side project key (it ships in the bundle by design —
 * not a secret). Override via REACT_APP_POSTHOG_KEY / _HOST if needed.
 */
import posthog from 'posthog-js';

const POSTHOG_KEY =
  process.env.REACT_APP_POSTHOG_KEY || 'phc_yqm367MCPDwZzdNN7pwcvp7639MtyxeixBryoAMRGu7m';
const POSTHOG_HOST =
  process.env.REACT_APP_POSTHOG_HOST || 'https://us.i.posthog.com';

let started = false;

export function initAnalytics() {
  if (started || !POSTHOG_KEY) return;
  // Only run in the production build, so local `yarn start` dev doesn't pollute
  // the project. Set REACT_APP_POSTHOG_DEV=1 to opt a dev build in for testing.
  if (process.env.NODE_ENV !== 'production' && process.env.REACT_APP_POSTHOG_DEV !== '1') return;
  started = true;
  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    // Anonymous visitors still generate events (visitor analytics / Web Analytics);
    // persistent person profiles are only created once a user is identified.
    person_profiles: 'identified_only',
    capture_pageview: true,
    capture_pageleave: true,
    autocapture: true,
    // Session replay — privacy-first. Recording also has to be enabled in the
    // PostHog project settings (Settings → Session Replay).
    disable_session_recording: false,
    session_recording: {
      maskAllInputs: true,
      maskTextSelector: '[data-ph-mask]',
    },
  });
}

/** Tie events to the logged-in user. Call after auth resolves. */
export function identifyUser(user) {
  if (!started || !user) return;
  try {
    posthog.identify(String(user.id || user.email), {
      email: user.email,
      roles: user.roles,
    });
  } catch (e) {}
}

/** Clear identity on logout so the next visitor is a fresh anonymous person. */
export function resetAnalytics() {
  if (!started) return;
  try { posthog.reset(); } catch (e) {}
}

export { posthog };
